import { CloseOutlined, Search } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import Popover from "@mui/material/Popover";
import { Theme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import type { JSX } from "react";
import { SearchContext } from "../../providers/SearchManagerProvider";
import WeaveBrandTheme from "../../themes/WeaveBrandTheme";
import GlobalSearchFlyout from "../GlobalSearchFlyout/GlobalSearchFlyout";
import { RenderTagFunc } from "../SearchResultsTag/SearchResultsTag";

export interface GlobalSearchBarProps {
    hideOrgSelector?: boolean;
    renderTags?: RenderTagFunc;
    onLinkClicked: (resourceId: string | undefined, tagIds: string[] | undefined) => void;
    onTagLinkClicked: (tagId: string) => void;
    onSearchAllButtonClicked: (query: string) => void;
}

export default function GlobalSearchBar(props: GlobalSearchBarProps): JSX.Element {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const searchManager = React.useContext(SearchContext);

    const open = Boolean(anchorEl);
    const id = open ? "search-results-popper" : undefined;

    return (
        <ThemeProvider theme={WeaveBrandTheme.light}>
            <Box sx={{ width: "fit-content" }}>
                <Button
                    variant="outlined"
                    data-testid="global-search-bar"
                    size="small"
                    fullWidth
                    aria-describedby={id}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(anchorEl ? null : e.currentTarget)}
                    sx={{
                        width: "280px",
                        backgroundColor: "rgba(100, 100, 100, 0.2) !important",
                        justifyContent: "flex-start",
                        textAlign: "left",
                    }}
                    startIcon={<Search sx={(theme: Theme) => ({ color: `${theme.palette.grey[500]} !important` })} />}
                    endIcon={
                        searchManager.query && (
                            <Icon onClick={() => searchManager.setQuery("")} data-testid="clear-query-button">
                                <CloseOutlined sx={(theme: Theme) => ({ color: theme.palette.grey[500] })} />
                            </Icon>
                        )
                    }
                >
                    <span className="fsr-btn-text">{searchManager.query || ""}</span>
                </Button>
                <Popover
                    id={id}
                    open={open}
                    disableRestoreFocus
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: "center",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "center",
                        horizontal: 300,
                    }}
                >
                    <GlobalSearchFlyout
                        onCloseClicked={() => setAnchorEl(null)}
                        onLinkClicked={props.onLinkClicked}
                        onTagLinkClicked={props.onTagLinkClicked}
                        onSearchAllButtonClicked={props.onSearchAllButtonClicked}
                        renderTags={props.renderTags}
                        hideOrgSelector={props.hideOrgSelector}
                    />
                </Popover>
            </Box>
        </ThemeProvider>
    );
}
